<template>
  <v-dialog v-model="open" max-width="630px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          v-bind="attrs"
          v-on="on"
          outlined
          elevation="1"
          :disabled="disabled"
          :class="actionClass"
          :color="actionColor">
        {{ actionText }}
      </v-btn>
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          {{ title }}
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        {{ description }}

        <v-alert
            v-if="alertScheduledTask"
            dense
            border="right"
            type="warning"
        >
          Existe um agendamento pendente para essa informação
        </v-alert>

        <schedule-form v-if="withSchedule" small v-on:change="changeScheduleDate" />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ScheduleForm from '@/views/Locations/Components/ScheduleForm';
import { TYPE_UPDATE_LOCATION_OPEN_INFO } from '@/constants/tasks';

export default {
  name: "LocationConfirmModal",
  props: {
    disabled: Boolean,
    actionText: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    action: {
      type: Function,
      required: true
    },
    actionColor: {
      type: String,
      default: 'primary'
    },
    actionClass: String,
    withSchedule: Boolean,
    alertScheduleTask: Array,
  },
  methods: {
    cancel: function() {
      this.open = false
    },
    callAction: async function () {
      this.loading = true
      await this.action(this.formData)
      this.open = false
      this.loading = false
    },
    changeScheduleDate: function(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_start_at = data.schedule_start_at
      this.formData.schedule_end = data.schedule_end
      this.formData.schedule_end_at = data.schedule_end_at
    }
  },
  components: {
    ScheduleForm
  },
  mounted() {
    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === TYPE_UPDATE_LOCATION_OPEN_INFO) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  data: () => ({
    open: false,
    loading: false,
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_OPEN_INFO,
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: ''
    },
    alertScheduledTask: null,
  })
}
</script>

<style scoped>

</style>